// extracted by mini-css-extract-plugin
module.exports = {"faq":"result_faq__F26qf","crumbsExtended":"result_crumbsExtended__4mPNz"};